import React, { ChangeEventHandler } from 'react';
import { Button, Checkbox } from '@ygtechnologies/rubus-ui';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { useAsyncState } from '@/utils/hooks';
import {
    ExportColumnDefinition,
    getRoomFormByUnitOrderExportColumns,
    RoomFormByUnitExportOptions,
} from '@/services/order-export';
import { ExportColumnSelection } from './ExportColumnSelection';

export interface RoomFormByUnitExportConfigurationProps {
    value: RoomFormByUnitExportOptions;
    onChange(newValue: RoomFormByUnitExportOptions): void;
}

function getDefaultOptions(columns: ExportColumnDefinition[] | null): RoomFormByUnitExportOptions {
    return {
        columns: columns ? columns.filter((x) => x.isDefault).map((x) => x.key) : [],
        includeFloorPlan: false,
    };
}

export const RoomFormByUnitExportConfiguration: React.FC<RoomFormByUnitExportConfigurationProps> = ({ value, onChange }) => {
    const [columns] = useAsyncState(() => getRoomFormByUnitOrderExportColumns(), [], null);
    const fixedValue: RoomFormByUnitExportOptions = {
        ...getDefaultOptions(columns),
        ...value,
    };

    const handleChange = (changes: Partial<RoomFormByUnitExportOptions>) => {
        onChange({ ...fixedValue, ...changes });
    };

    const resetToDefaults = () => {
        onChange(getDefaultOptions(columns));
    };

    if (!columns) {
        return null;
    }

    return (
        <div>
            {/* <div>
                <Checkbox
                    checked={fixedValue.includeFloorPlan}
                    onChange={(e) => handleChange({ includeFloorPlan: e.target.checked })}>
                    <Trans>Include floor plans</Trans>
                </Checkbox>
                <hr />
            </div> */}

            <ExportColumnSelection
                value={fixedValue.columns}
                onChange={(newValue) => handleChange({ columns: newValue })}
                columns={columns}
            />

            <Button variant="primary" onClick={resetToDefaults}>
                <Trans>Reset to default</Trans>
            </Button>
        </div>
    );
};
